export const DENIED_UKNOWN_TAG_IN_ID = '38';
export const DENIED_UKNOWN_TAG_OUT_ID = '39';

export const isQuickEnrollEvent = (eventId: string, credentialHolder: string): boolean => {
    return ( (eventId === DENIED_UKNOWN_TAG_IN_ID || eventId === DENIED_UKNOWN_TAG_OUT_ID) && credentialHolder === '-');
}